import { APCalculatorBase } from '../../../components/tools/APCalculatorBase';

const frqQuestions = [
  {
    name: "Create Performance Task",
    maxScore: 6,
    weight: 0.3,
    description: "Program design and implementation"
  }
];

const apCSPConfig = {
  title: "AP Computer Science Score Calculator | AP CSP score calculator",
  description: "Calculate your AP Computer Science Principles exam score instantly with our comprehensive calculator. Updated for 2025 AP CSP exam format.",
  keywords: [
    "AP CSP score calculator",
    "AP CSP calculator",
    "AP Computer Science Principles score calculator",
    "AP CSP score estimation",
    "2025 AP CSP scoring",
    "AP CS Principles calculator"
  ],
  mcqTotal: 70,
  frqQuestions,
  mcqWeight: 0.7,
  frqWeight: 0.3,
  path: "/tools/ap-csp-score-calculator",
  examSpecificInfo: {
    fullName: "AP Computer Science Principles",
    examFormat: "Multiple choice (70 questions, 2 hours) and performance task (1 project submitted digitally)",
    passingRate: "Approximately 71% of students score 3 or higher",
    collegeCredit: "Many colleges offer credit for scores of 3 or higher"
  }
};

export function APCSPCalculator() {
  return <APCalculatorBase config={apCSPConfig} />;
}